import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'allocatedUnitState';

export const getAllocatedUnits = createAsyncThunk(
    'allocatedUnits/fetchAll',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/allocatedUnits`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            console.error('ERROR FETCHING ALLOCATED UNITS', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    allocatedUnits: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
};

const allocatedUnitSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllocatedUnits.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllocatedUnits.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.allocatedUnits = action.payload;
            })
            .addCase(getAllocatedUnits.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default allocatedUnitSlice.reducer;